export const startOfCurrentDay = () => {
  const currentDay = new Date();
  currentDay.setHours(0, 0, 0, 0);
  return currentDay;
};
